export default __webpack_public_path__ + "img/5f4eeabafa40ec18b56424cbe45911a6.png";